import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-chart-bar2-icon',
  templateUrl: './shopping-chart-bar2.component.html'
})
export class ShoppingChartBar2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
